import {
  IconDefinition,
  IconName,
  IconPrefix,
} from '@fortawesome/fontawesome-svg-core';

/**
 * Duotone brush from Font Awesome Pro 7.1.0 (svgs/duotone/brush.svg).
 * Two-layer icon: the bristle head renders as `.fa-secondary` and the
 * ferrule + handle as `.fa-primary`, so they can be colored independently
 * via `--fa-secondary-color` / `--fa-primary-color`.
 */
export const faBrushDuotone: IconDefinition = {
  prefix: 'fac' as IconPrefix,
  iconName: 'brush-duotone' as IconName,
  icon: [
    384,
    512,
    [],
    '',
    [
      'M0 48l0 240 384 0 0-240c0-26.5-21.5-48-48-48L230.5 0c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6c-1.5-3.6-5-6-8.9-6l-19 0c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6L48 0C21.5 0 0 21.5 0 48z',
      'M0 288l384 0 0 32c0 35.3-28.7 64-64 64l-64 0 0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64-64 0c-35.3 0-64-28.7-64-64l0-32zM192 464c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z',
    ],
  ],
};
